import { Stack, Text } from '@mantine/core';
import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/PageHeader';
import { LabeledValue } from '@/components/LabeledValue';
import { MainContainer } from '@/components/MainContainer';
import { PendingInitialize } from '@/components/PendingInitialize';

export const Route = createFileRoute('/_main/_project/project/settings/')({
  component: Component,
  pendingComponent: () => <PendingInitialize title="プロジェクト" />,
});

function Component() {
  const { project, projectId } = Route.parentRoute.useLoaderData();
  const isArchived = project?.status === 'archived';

  return (
    <MainContainer>
      <PageHeader title="プロジェクト情報" />
      {isArchived && <Text c="red">このプロジェクトはアーカイブされています。</Text>}
      {!projectId && <Text>右上のプロジェクト選択から、プロジェクトを選択してください。</Text>}
      {projectId && !project && (
        <Text>
          プロジェクトが見つかりませんでした。
          <br />
          右上のプロジェクト選択から、プロジェクトを選択してください。
        </Text>
      )}
      {projectId && project && (
        <Stack className="my-3" maw="350px">
          <LabeledValue label="名前" value={project.name} />
          <LabeledValue label="ID" value={project.id} copyable />
        </Stack>
      )}
    </MainContainer>
  );
}
